/* eslint-disable */
export default {
  confirmationInfo:
    'Aiemman puhelusi tallentamattomat muokkaukset menetetään. Oletko varma, että haluat työstää uutta puhelua?',
  log: 'Loki',
  save: 'Tallenna ja työstä uutta',
  discard: 'Hylkää ja työstä uutta',
  stay: 'Jatka aiempaa työstämistä',
} as const;

// @key: @#@"confirmationInfo"@#@ @source: @#@"Your unsaved edits on the previous call will be lost, are you sure you want to work on the new call?"@#@
// @key: @#@"log"@#@ @source: @#@"Log"@#@
// @key: @#@"save"@#@ @source: @#@"Save & Work on New"@#@
// @key: @#@"discard"@#@ @source: @#@"Discard & Work on New"@#@
// @key: @#@"stay"@#@ @source: @#@"Stay on Previous Work"@#@
